export default __webpack_public_path__ + "static/media/prev-Multi-GNSS-Modules-4.563d2b3a.png";